<script setup lang="ts">
import CBaseHeader from '@/presentation/components/base/CBaseHeader.vue'
import { storeToRefs } from 'pinia'
import { default as PMessage } from 'primevue/message'
import { default as PProgressSpinner } from 'primevue/progressspinner'
import { default as PButton } from 'primevue/button'
import { computed, ref, type Ref } from 'vue'
import { useUsersStore } from '@/presentation/stores/users/users.ts'

// Composables
const usersStore = useUsersStore()

// Store refs
const { usersStoreError } = storeToRefs(usersStore)

// Refs
const localError: Ref<string | null> = ref(null)

// Computed
const loading = computed(() => {
  return false
})

const hasError = computed(() => {
  return (localError.value !== null || usersStoreError.value.hasError) ?? false
})
</script>

<template>
  <c-base-header title="Utilisateurs" :display-breadcrumbs="false" :has-widget="true">
    <template #widgets>
      <router-link :to="{ name: 'create-user' }">
        <p-button label="Ajouter un utilisateur" icon="pi pi-plus" size="small" />
      </router-link>
    </template>
  </c-base-header>
  <div class="col-span-12 flex-1 gap-8 overflow-y-auto p-8 pt-2 min-h-0">
    <!-- Affichage des erreurs -->
    <p-message v-if="hasError" severity="error" :closable="false" class="mb-4">
      {{ usersStoreError.message }}
    </p-message>

    <!-- État de chargement principal -->
    <div v-if="loading && !hasError" class="flex flex-col items-center justify-center p-8">
      <p-progress-spinner style="width: 50px; height: 50px" strokeWidth="5" />
      <p class="mt-4 text-lg">Chargement des données...</p>
    </div>
    <!-- Contenu de la page -->
    <router-view v-else />
  </div>
</template>